<ng-template #blacklistDialogTemplate>
  <div class="bla-dialog bg-dark border border-darkgray rounded-2">
    <!-- Header -->
    <div class="bla-header">
      <div class="bla-title-group">
        <span class="bla-eyebrow">Blacklist Area</span>
        <span class="bla-title">{{ isEditingExistingArea() ? 'Edit Rule' : 'Create Rule' }}</span>
      </div>
      <span class="rb-ic rb-ic-close bla-close-btn" (click)="closeDialog()"></span>
    </div>

    <!-- Scrollable body -->
    <div class="bla-body">
      <!-- Sign type selection -->
      <div class="bla-section">
        <button
          type="button"
          class="bla-section-toggle"
          (click)="signSectionCollapsed = !signSectionCollapsed"
        >
          <span class="bla-section-label">Sign Type</span>
          <span
            class="rb-ic bla-section-chevron"
            [class.rb-ic-down]="signSectionCollapsed"
            [class.rb-ic-up]="!signSectionCollapsed"
          ></span>
        </button>

        @if (!signSectionCollapsed) {
          <div class="bla-sign-grid">
            @for (sign of availableSigns; track sign) {
              <button
                type="button"
                class="bla-sign-chip"
                [class.selected]="selectedSign === sign"
                [class.speed-sign]="isSpeedSignType(sign)"
                (click)="onSignSelect(sign)"
                [title]="formatSignLabel(sign)"
              >
                {{ formatSignLabel(sign) }}
              </button>
            }
          </div>
        }
      </div>

      <!-- Speed selection — only for speed-type signs -->
      @if (isCurrentSignSpeedType) {
        <div class="bla-section bla-section--speed">
          <button
            type="button"
            class="bla-section-toggle"
            (click)="speedSectionCollapsed = !speedSectionCollapsed"
          >
            <div class="bla-section-label-row">
              <span class="bla-section-label">Speeds</span>
              @if (selectedSpeeds.length === 0) {
                <span class="bla-all-speeds-badge">
                  <span class="rb-ic rb-ic-warning-notice" style="font-size: 0.7rem"></span>
                  All speeds
                </span>
              } @else {
                <span class="bla-speed-count-badge">{{ selectedSpeeds.length }}</span>
              }
            </div>
            <span
              class="rb-ic bla-section-chevron"
              [class.rb-ic-down]="speedSectionCollapsed"
              [class.rb-ic-up]="!speedSectionCollapsed"
            ></span>
          </button>

          @if (!speedSectionCollapsed) {
            <!-- Common speed chips -->
            <div class="bla-speed-chips mb-2">
              @for (speed of commonSpeeds; track speed) {
                <button
                  type="button"
                  class="bla-speed-chip"
                  [class.selected]="isSpeedSelected(speed)"
                  (click)="toggleSpeed(speed)"
                >
                  {{ speed }}
                </button>
              }
            </div>
          }
        </div>
      }
    </div>

    <!-- Summary -->
    <div class="bla-summary">
      <span class="bla-summary-sign">{{ formatSignLabel(selectedSign) }}</span>
      @if (isCurrentSignSpeedType) {
        <span class="bla-summary-sep">·</span>
        <span class="bla-summary-speeds">{{ speedSummaryLabel }}</span>
      }
    </div>

    <!-- Actions -->
    <div class="bla-actions">
      <button
        type="button"
        class="rb-btn"
        [class.rb-primary]="!isEditingExistingArea() || hasChanges()"
        [class.rb-secondary]="isEditingExistingArea() && !hasChanges()"
        [disabled]="isEditingExistingArea() && !hasChanges()"
        (click)="saveBlacklistArea()"
      >
        <span
          class="rb-ic me-1"
          [class.rb-ic-refresh]="isEditingExistingArea()"
          [class.rb-ic-add]="!isEditingExistingArea()"
        ></span>
        {{ isEditingExistingArea() ? 'Update' : 'Create' }}
      </button>

      @if (isEditingExistingArea()) {
        <button type="button" class="rb-btn rb-danger" (click)="deleteBlacklistArea()">
          <span class="rb-ic rb-ic-delete"></span>
          Delete
        </button>
      }
    </div>
  </div>
</ng-template>
